module.exports = __webpack_public_path__ + "static/media/totalValueIcon.74c3bcda.svg";